import React from 'react';

import Close from '@material-ui/icons/Close';
import Add from '@material-ui/icons/Add';
import styles from './styles/styles.module.scss';

// todo: we already have a very similar component, 'collapsible' but it does not use CSS Modules and it's in the old components directory.
//       Leaving this todo here to remember to replace references to 'collapsible' in the converter with this Expandable component.
class Expandable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCollapsed: this.props.isCollapsed || true
    };
  }

  toggleContent = () => {
    this.setState(prevState => ({
      isCollapsed: !prevState.isCollapsed
    }));
  };

  render() {
    return (
      <div className={styles.container}>
        <div onClick={this.toggleContent} className={styles.control}>
          <div className={styles.title}>{this.props.title}</div>
          <div className={styles.toggleButton}>{this.state.isCollapsed ? <Add /> : <Close />}</div>
        </div>
        <div className={`${styles.content} ${this.state.isCollapsed ? styles.collapsed : styles.collapsible}`}>{this.props.children}</div>
      </div>
    );
  }
}

export default Expandable;
